import React from 'react'
import PropTypes from 'prop-types'
import { CToast, CToastHeader, CToastBody, CToastClose } from '@coreui/react'

const ErrorNotification = ({ tittle, message }) => {
  return (
    <CToast autohide={true} color="danger" className="align-items-center" title="ErrorNotification">
      <CToastHeader className="text-white">
        <strong className="me-auto">{tittle}</strong>
        <CToastClose className="me-2 m-auto" white />
      </CToastHeader>
      <div className="d-flex">
        <CToastBody className="text-white">{message}</CToastBody>
      </div>
    </CToast>
  )
}

ErrorNotification.propTypes = {
  tittle: PropTypes.string,
  message: PropTypes.string,
}

export default ErrorNotification
